export default __webpack_public_path__ + "static/media/reset-password.ae97448a.jpg";